import api from './api';

// Ekibimin İzinleri — çağıranın ekibinin (yönetici, doğrudan ekip arkadaşları, tüm kademe astlar) bugünkü ve aylık
// onaylı/bekleyen izinleri. year/month verilmezse sunucu içinde bulunulan ayı seçer ve gezinme penceresini döner.
const clean = (params) => {
  const out = {};
  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== null && value !== undefined && value !== '') out[key] = value;
  });
  return out;
};

export const getMyTeamLeavesToday = () => api.get('/v1/my-team-leaves/today');

export const getMyTeamLeavesTimeline = ({ year, month, page } = {}) =>
  api.get('/v1/my-team-leaves/timeline', { params: clean({ year, month, page }) });
